<mat-card>
  <form [formGroup]="form" (ngSubmit)="save()">
    <mat-card-header>
      <mat-card-title translate="accounts/edition/kakaotalk-engagement/title"></mat-card-title>
    </mat-card-header>

    <mat-card-content>
      <mat-form-field appearance="outline" class="shrink" [floatLabel]="'always'">
        <mat-label>{{ 'accounts/edition/kakaotalk-engagement/sender-key/label' | translate }}</mat-label>
        <input autocomplete="off" type="text" formControlName="senderKey" matInput />
      </mat-form-field>
    </mat-card-content>

    <mat-card-actions>
      <button type="submit" mat-raised-button [disabled]="form.pristine || form.invalid" color="primary">
        <span [translate]="'save'"></span>
      </button>
    </mat-card-actions>
  </form>
</mat-card>
